export const InvestorUpdates = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.16667 7C8.16667 7.59442 7.987 8.14567 7.68133 8.6065L5.83333 6.7585V4.14225C7.1645 4.41233 8.16667 5.58892 8.16667 7ZM4.66667 4.14225C3.3355 4.41233 2.33333 5.58892 2.33333 7C2.33333 8.61058 3.63942 9.91667 5.25 9.91667C5.84442 9.91667 6.39567 9.737 6.8565 9.43133L4.66667 7.2415V4.14225ZM9.33333 5.25H11.6667V4.08333H9.33333V5.25ZM9.33333 7.58333H11.6667V6.41667H9.33333V7.58333ZM9.33333 9.91667H11.6667V8.75H9.33333V9.91667ZM14 3.5V12.25H0V3.5C0 2.53517 0.785167 1.75 1.75 1.75H12.25C13.2148 1.75 14 2.53517 14 3.5ZM12.8333 3.5C12.8333 3.17858 12.572 2.91667 12.25 2.91667H1.75C1.428 2.91667 1.16667 3.17858 1.16667 3.5V11.0833H12.8333V3.5Z"
      fill="currentColor"
    />
  </svg>
);
